module.exports = __webpack_public_path__ + "img/report_img_202109.5415ea39.jpg";